import React from 'react';
import { hot } from 'react-hot-loader/root';

import { useModalStore } from 'bdvp-common/src/hooks/store';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import Component from '../components/App';

const { FILTER_MODAL_NAME } = modalConstants;

const App = () => {

    const { modals } = useModalStore();

    return <Component isFilterActive={modals[FILTER_MODAL_NAME] || false} />;

};

export default hot(App);
